import React from 'react';
import { PRIVACY_POLICY, TERMS_OF_SERVICE } from '../legalContent';
import '../App.css';

const sections = [
  { id: 'privacy', title: 'Privacy Policy', content: PRIVACY_POLICY },
  { id: 'terms', title: 'Terms of Service', content: TERMS_OF_SERVICE }
];

const LegalPage = () => {
  const handleBack = () => {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.assign('/');
    }
  };

  return (
    <div className="legal-page">
      <header className="legal-hero">
        <div className="legal-hero-inner">
          <p className="legal-eyebrow">Kwajongen.com</p>
          <h1>Legal Information</h1>
          <p className="legal-intro">
            Access our current Privacy Policy and Terms of Service. These documents explain how we protect your data and how play on Kwajongen works.
          </p>
          <div className="legal-hero-actions">
            <button type="button" className="legal-back-btn" onClick={handleBack}>
              ← Back to App
            </button>
            <div className="legal-section-links">
              {sections.map((section) => (
                <a key={section.id} href={`#${section.id}`} className="legal-anchor-link">
                  {section.title}
                </a>
              ))}
            </div>
          </div>
        </div>
      </header>

      <main className="legal-content">
        {sections.map((section) => (
          <section key={section.id} id={section.id} className="legal-card">
            <h2>{section.title}</h2>
            <pre className="legal-text" aria-label={section.title}>
              {section.content}
            </pre>
          </section>
        ))}
      </main>
    </div>
  );
};

export default LegalPage;
